import httpAdmin from '@/httpCommon/axiosClient';
class ImportService {
    importCSV = (file: File, url: string) => {
        const formData = new FormData();
        formData.append('file', file);
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        return httpAdmin.post(url, formData, config);
    };

    importProductCSV = (body: any, url: string) => {
        const formData = new FormData();
        const file: File = body.file;
        const stores = body.stores;
        formData.append('file', file);
        formData.append('stores', stores);
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        return httpAdmin.post(url, formData, config);
    };

    importPlanCSV = (body: any, url: string) => {
        const formData = new FormData();
        const file: File = body.file;
        formData.append('file', file);
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        return httpAdmin.post(url, formData, config);
    };
}
export default new ImportService();
